export default __webpack_public_path__ + "static/color-emphasis-level-inverse-light-eb67bfb55cebb6d04f0fd8a55a6ef7271c0c442d679bc1f49430626ccc9c384d.png";